import styled from 'styled-components';
import { ActionButton } from '../styles';
import { getAuthUrl } from './utils/getAuthUrl';

export const DirectAuthLink = styled(ActionButton)
    .withConfig({
        displayName: 'DirectAuthLink',
    })
    .attrs({
        as: 'a',
        href: getAuthUrl(),
    })`
`;
